/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { TableCell, TableHead } from '@material-ui/core';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableContainer from '@mui/material/TableContainer';
import theme from '../../styles/defaultTheme';

export const Pagination = styled(TablePagination)`
	& .MuiTablePagination-selectLabel, .MuiInputBase-root.MuiTablePagination-select, 
	.MuiSelect-select-MuiInputBase-input.MuiSelect-select-MuiInputBase-input
	.MuiSelect-select-MuiInputBase-input{
		display: none;
	}
`;

export const CustomTableContainer = styled(TableContainer)`
    overflow: hidden;
	border-radius: 8px 8px 0px 0px;

	.MuiPaginationItem-root {
		font-size: ${theme.font.size16};
	}

	${({ contrastTheme }) => (!contrastTheme ? `border: solid 1px transparent !important;` : `border: solid 1px #FFFFFF;`)}
`;

export const CustomTableHead = styled(TableHead)`
	background: ${(props) => props.theme.darkGrey};
	color: ${(props) => props.theme.whiteLink};
	text-align: left !important;
	height: 44px;
	

	tr > th {
		font: ${theme.font.table.header};
		padding: 13px 13px;
	}

	tr > th > span {
		height: 15px;
	}
	
	tr > td {
		font: ${theme.font.table.body}; 
	}
	
	& th[aria-sort="ascending"] {
		& .material-icons-outlined:last-child {
			display: none;
		}		
	}
	
	& th[aria-sort="descending"] {
		& .material-icons-outlined {
			margin-top: 0px !important;
		}		
	}
	
	& th[aria-sort="descending"] {
		& .material-icons-outlined:first-child {
			display: none;
			margin-bottom: 0;
		}		
	}

	.MuiButtonBase-root.MuiTableSortLabel-root.Mui-active{
		color: ${(props) => props.theme.whiteLink};
	};
	
	.MuiButtonBase-root{
		:hover{
			color: ${(props) => props.theme.whiteLink};
		}
	}
	
	.MuiTableCell-root{
		padding: 0 12px;
		text-align: left !important;
		flex-direction: revert;
	};
	
	.MuiTableCell-root:first-child{
		padding: 0 12px 0 24px;
	}
	
	.MuiToolbar-root.MuiTablePagination-toolbar{
		background-color: transparent;
	}
`;

export const CustomTableRow = styled(TableRow)`
	background-color: ${(props) => props.theme.white} !important;

	td {
			${({ clickableRowS, contrastTheme }) =>
                clickableRowS && contrastTheme
                    ? `color: #FFF333 !important`
                    : clickableRowS && !contrastTheme
                    ? `color: #1A171B !important`
                    : !clickableRowS && contrastTheme
                    ? `color: #FFFFFF !important`
                    : !clickableRowS && !contrastTheme
                    ? `color: #1A171B !important`
                    : ``};
		}

	:hover{	
		${({ clickableRowS, contrastTheme }) =>
            clickableRowS && contrastTheme
                ? `background-color: #FFF333 !important`
                : clickableRowS && !contrastTheme
                ? `background-color: #F9EDD3 !important`
                : !clickableRowS && contrastTheme
                ? `background-color: none !important`
                : !clickableRowS && !contrastTheme
                ? `background-color: none !important`
                : `background-color: none !important`};

		td {
			${({ clickableRowS, contrastTheme }) =>
                clickableRowS && contrastTheme
                    ? `color: #1A171B !important`
                    : clickableRowS && !contrastTheme
                    ? `color: #1A171B !important`
                    : !clickableRowS && contrastTheme
                    ? `color: #FFFFFF !important`
                    : !clickableRowS && !contrastTheme
                    ? `color: #1A171B !important`
                    : ``};
		}
	}
`;

export const CustomTableCell = styled(TableCell)`
	font-size: ${theme.font.size14} !important;
	font-family: "Oxygen" !important;
	letter-spacing: 0px;
	color: ${(props) => props.theme.blackLink} !important;
`;

export const AlignIconSort = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;	
`;

export const PaginationText = styled.div`
    font: ${theme.font.body[3]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.orangeLink};
    text-decoration: underline;
`;

export const PaginationContainer = styled.div`	
	margin: 32px 0 32px 0;
	display: flex;
	justify-content: center;

	.MuiPaginationItem-root {
		font-size: ${theme.font.size16};
	}
	
	& .MuiButtonBase-root.MuiPaginationItem-root {
		background-color: ${(props) => props.theme.backgroundTransparent};
		color: ${(props) => props.theme.orangeLink};
		border: solid 1px ${(props) => props.theme.orangeLink};
		border-radius: 8px;
		margin: 0 4px;
		padding-top: 1px;
	}

	& .MuiButtonBase-root.MuiPaginationItem-root:hover {
		background-color: ${(props) => props.theme.backgroundTransparent};
	}

	& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected {
		background-color: ${(props) => props.theme.orangeToBlack};
		color: #FFFFFF;
		border-color: ${(props) => props.theme.orange};
	}

	& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected :not(.nohover):hover {
		background-color: ${(props) => props.theme.orange};
	}

	& .MuiPaginationItem-ellipsis {
		color: ${(props) => props.theme.black};
	}
`;
